import {
  deadlineStatusColorMap,
  deadlineStatusLabelMap,
  projectStatusColorMap,
  projectStatusLabelMap,
  workflowStatusColorMap,
  workflowStatusLabelMap,
} from "@/constants";
import { type AppLocale, DEFAULT_LOCALE } from "@/i18n/locale";
import { formatSidebarDueDate } from "@/lib/formatDate";
import type { Role } from "@/lib/permissions";
import type {
  AviItem,
  DeadlineColor,
  DeadlineFilterStatus,
  DeadlineStatus,
  ProjectStatus,
  ProjectStatusColor,
  WorkflowColor,
  WorkflowStatus,
} from "@/types";

const COMPLETED_WORKFLOW_STATUSES_BY_ROLE: Partial<Record<Role, WorkflowStatus[]>> = {
  ev: ["le_review", "pm_review", "approved"],
  le: ["pm_review", "approved"],
  pm: ["approved"],
};

// Workflow
export function getWorkflowStatusLabel(status: WorkflowStatus): string {
  return workflowStatusLabelMap[status];
}

export function getWorkflowStatusColor(status: WorkflowStatus): WorkflowColor {
  return workflowStatusColorMap[status];
}

// Project Status
export function getProjectStatusLabel(status: ProjectStatus): string {
  return projectStatusLabelMap[status];
}

export function getProjectStatusColor(status: ProjectStatus): ProjectStatusColor {
  return projectStatusColorMap[status];
}

// Deadline
export function getDeadlineStatusLabel(deadlineStatus: DeadlineFilterStatus): string {
  if (deadlineStatus === "completed") return "Completed";
  return deadlineStatusLabelMap[deadlineStatus];
}

export function getDeadlineStatusColor(deadlineStatus: DeadlineStatus): DeadlineColor {
  return deadlineStatusColorMap[deadlineStatus];
}

export function isDeadlineCompletedForRole(role: Role, workflowStatus: WorkflowStatus): boolean {
  return COMPLETED_WORKFLOW_STATUSES_BY_ROLE[role]?.includes(workflowStatus) ?? false;
}

/** Returns unique projects (by code) from the AVI list. */
export function getProjectsFromAviList(items: AviItem[]): { project_code: string }[] {
  const seen = new Set<string>();
  return items.reduce<{ project_code: string }[]>((acc, item) => {
    if (!seen.has(item.project_code)) {
      seen.add(item.project_code);
      acc.push({ project_code: item.project_code });
    }
    return acc;
  }, []);
}

export function formatDueDate(dateStr: string, locale: AppLocale = DEFAULT_LOCALE): string {
  return formatSidebarDueDate(dateStr, locale);
}
